import { createBrowserHistory } from "history";

import {ClickAnalyticsPlugin} from "@microsoft/applicationinsights-clickanalytics-js";
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
const browserHistory = createBrowserHistory({ basename: '' });

const reactPlugin = new ReactPlugin();

const clickPluginInstance = new ClickAnalyticsPlugin();
const clickPluginConfig = {
    autoCapture: true
};

const connectionStringEnv = import.meta.env.VITE_APP_APP_INSIGHTS_CONNECTION_STRING;

const connectionString =
    connectionStringEnv !== '' ? connectionStringEnv : 'InstrumentationKey=blank';

const isDevelopment = import.meta.env.VITE_APP_ENVIRONMENT === '0';

const appInsights = new ApplicationInsights({
    config: {
        connectionString: connectionString,
        enableAutoRouteTracking: true,
        disableTelemetry: isDevelopment,
        extensions: [reactPlugin, clickPluginInstance],
        extensionConfig: {
            [reactPlugin.identifier]: { history: browserHistory },
            [clickPluginInstance.identifier]: clickPluginConfig
        }
    }
});
appInsights.loadAppInsights();
appInsights.trackPageView();

export { appInsights, reactPlugin };